const KEY = "edhub:favorites";

export function readFavorites(): Set<string> {
	try {
		const raw = globalThis.localStorage?.getItem(KEY);
		if (!raw) return new Set();
		const arr = JSON.parse(raw);
		return Array.isArray(arr)
			? new Set(arr.filter((x) => typeof x === "string"))
			: new Set();
	} catch {
		return new Set();
	}
}

function write(set: Set<string>): void {
	try {
		globalThis.localStorage?.setItem(KEY, JSON.stringify([...set]));
	} catch {
		/* no-op: private mode / storage unavailable */
	}
}

export function isFavorite(id: string): boolean {
	return readFavorites().has(id);
}

/** Flip membership, persist, return the new favorited state. */
export function toggleFavorite(id: string): boolean {
	const set = readFavorites();
	const next = !set.has(id);
	if (next) set.add(id);
	else set.delete(id);
	write(set);
	return next;
}
